export class SignatureConfig {
    enterpriseName: SignatureConfigItem;
    greenTick: SignatureConfigItem;
    phoneNumber: SignatureConfigItem;
    signingTime: SignatureConfigItem;
    position: SignatureConfigItem;
    address: SignatureConfigItem;
    confirmBy: SignatureConfigItem;
    signatureImage: SignatureConfigItem;
    fontSize: SignatureConfigItem;
    fontFamily: SignatureConfigItem;
    fontStyle: SignatureConfigItem;
    fontWeight: SignatureConfigItem;
    signaturePosition: SignatureConfigItem;
    signatureImageBase64: SignatureConfigItem;
    signatureRatio: SignatureConfigItem;
    signatureImageName: SignatureConfigItem;
    isDraw: SignatureConfigItem;
    email: SignatureConfigItem;
    contentPosition: SignatureConfigItem;
    customSymbol?: SignatureConfigItem;
    organizationName?: SignatureConfigItem;

  public static build(): SignatureConfig {
        const signConfig = new SignatureConfig();
        const configValueDefault = (label: string) => {
            return {
                value: null,
                enabled: false,
                label
            };
        };
        const configWithValue = (value: string) => {
          return {
            value,
            enabled: false,
            label: null
          };
        };
        const configDefaultValue = (value: any, enable: boolean, label: string) => {
          return {
            value,
            enabled: enable,
            label: label
          };
        };

        signConfig.enterpriseName = configValueDefault('enterprise_contract.image_signing.no_image.enterprise_name');
        signConfig.greenTick = configDefaultValue(null, true, '');
        signConfig.phoneNumber = configValueDefault('enterprise_contract.image_signing.no_image.phone_number');
        signConfig.signingTime = configValueDefault('enterprise_contract.image_signing.no_image.signing_time');
        signConfig.position = configValueDefault('enterprise_contract.image_signing.no_image.position');
        signConfig.address = configValueDefault('enterprise_contract.image_signing.no_image.address');
        signConfig.email = configValueDefault('enterprise_contract.panel_document.table_parties.header.email');
        signConfig.confirmBy = configValueDefault('enterprise_contract.image_signing.no_image.confirm_by');
        signConfig.signatureImage = configValueDefault('');
        signConfig.fontSize = configValueDefault('');
        signConfig.fontFamily = configWithValue('Times-Roman');
        signConfig.fontStyle = configValueDefault('');
        signConfig.fontWeight = configValueDefault('');
        signConfig.signaturePosition = configWithValue('');
        signConfig.signatureImageBase64 = configValueDefault('');
        signConfig.signatureRatio = configWithValue('30:70');
        signConfig.signatureImageName = configWithValue('');
        signConfig.isDraw = configValueDefault('');
        signConfig.contentPosition = configWithValue(ContentPosition.left);
        return signConfig;
    }
}

export function setSignConfig(signConfig: SignatureConfig, data: any){

}

interface SignatureConfigItem {
    value?: any;
    enabled: boolean;
    label: string;
}

export const enum ContentPosition {
  'left'= 'left',
  'center' = 'center',
  'right' = 'right'
}
